import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getDetailsCourseActions } from "../slices";
import { showFailureToast } from "@helpers";
import { filterLessonValid } from "./getCourseLearning";

function* getDetailsCourseWorker({ payload }) {
  try {
    yield put(getDetailsCourseActions.pending());
    const response = yield call(courseAPI.getDetailsCourse, payload);
    // Temp logic to get lesson
    const { data } = response;
    const sectionsMapped = filterLessonValid(data.sections);
    const newPayload = {
      ...response,
      data: { ...data, sections: sectionsMapped },
    };
    // End temp logic
    yield put(getDetailsCourseActions.success(newPayload));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getDetailsCourseActions.failure(error));
    yield call(
      showFailureToast,
      error?.Message || error?.message || "Can not get info this course!"
    );
    // TODO: handle callback | onFailure
  }
}

export { getDetailsCourseWorker };
